// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.settings_dashboard__FHk5D {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 35px 35px;
  border-radius: 0px;
  min-height: auto !important;
  background-color: #f5f6fa;
  height: calc(100vh - 160px);
  overflow-y: auto;
}

.settings_dashboardContain__U2OSm {
  width: calc(100% - 320px);
  background-color: #f5f6fa;
  border-radius: 8px;
}

.settings_bodythemedark__CUjRX .settings_dashboardContain__U2OSm,
.settings_bodythemedark__CUjRX .settings_dashboard__FHk5D,
.settings_bodythemedark__CUjRX .settings_cont2__VlNwH {
  background-color: #0f1824;
}

.settings_top_header__ff-Zj .settings_top_header_inner__CdYKG {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.settings_cont2__VlNwH {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #f5f6fa;
  height: calc(100vh - 160px);
  min-height: auto !important;
  overflow-y: auto;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.settings_subLink__DFs3N svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.settings_footer__P4xQU {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.settings_bodythemelight__daVLj {
  background-color: #fff;
  padding-top: 90px;
}

.settings_bodythemedark__CUjRX {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.settings_headerthemelight__-DecU {
  background-color: #fff;
}

.settings_headerthemedark__VXMQL {
  background-color: #132337;
}

.settings_top_header__ff-Zj {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
  top: 0;
}

/* 
LEFT MENU THEME CHANGE
*/
.settings_menuthemelight__xa936 {
  background-color: #fff;
}

.settings_menuthemedark__0RlW9 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.settings_menulinklight__2ukHf span {
  color: #666666 !important;
}

.settings_menulinklight__2ukHf a {
  color: #cbcbcb !important;
}

.settings_menulinklight__2ukHf:hover span,
.settings_menulinklight__2ukHf:hover a {
  color: #fff !important;
}

.settings_menulinkdarkSelected__qg5eL {
  background-color: #1c2e45;
  color: #3b82f6;
}

.settings_menuthemelight__xa936 .settings_menulinklightSelected__-Sh8x {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #0f4d0f;
}

.settings_menuthemelight__xa936 .settings_menulinklightSelected__-Sh8x svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.settings_menulinkdark__ZEp0Q {
  color: #92afd3 !important;
}

.settings_menulinklight__2ukHf:hover {
  color: #fff !important;
  background-color: #0f4d0f;
}

.settings_menulinklight__2ukHf:hover svg path {
  color: #fff !important;
  fill: #fff;
  stroke: #fff;
}

.settings_menulinklight__2ukHf .settings_sub_arrow__fGoo- svg path {
  stroke: #cbcbcb !important;
}

.settings_menulinklight__2ukHf:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinkdark__ZEp0Q .settings_sub_arrow__fGoo- svg path {
  stroke: #92afd3 !important;
}

.settings_menulinkdark__ZEp0Q:hover .settings_sub_arrow__fGoo- svg path {
  stroke: #fff !important;
}

.settings_menulinkdark__ZEp0Q:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.settings_headinglight__doSQ0 {
  color: #60677e;
}

.settings_headingdark__n\\+TEX {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.settings_searchboxlight__Exe8H {
  background-color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy {
  background-color: #132337;
  color: #fff;
  border: none;
}

.settings_searchboxdark__0LYGy::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.settings_tableheadlight__I2wDM {
  background-color: #131f43;
  border-radius: 5px 5px 0px 0px;
}

.settings_tableheadlight__I2wDM th {
  color: #fff;
  background-color: #0f4d0f;
}

thead .settings_tableheadlight__I2wDM th:first-child,
thead .settings_tableheaddark__BAzcZ th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .settings_tableheadlight__I2wDM th:last-child,
thead .settings_tableheaddark__BAzcZ th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.settings_table__wcs2I.settings_table-borderless__XlVcO {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.settings_tableheaddark__BAzcZ {
  background-color: #132337;
  color: #fff;
}

.settings_table-borderless__XlVcO tr:nth-child(even) {
  background-color: #f9fafb;
}

.settings_table-borderless__XlVcO .settings_left-section__Mo-jA {
  padding-top: 10px;
}

.settings_tablebodylight__F8haX td,
.settings_tablebodydark__qeszF td {
  padding: 0.5rem 1rem !important;
  line-height: 30px;
}

.settings_tablebodylight__F8haX {
  background-color: #fff;
}
.settings_tablebodylight__F8haX:hover {
  background-color: #ddecf9;
  cursor: auto;
}

.settings_tablebodydark__qeszF {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.settings_tablebodydark__qeszF:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: auto;
}

/* 
PAGINATION THEME COLOR
*/
.settings_paginationlight__BGULt {
  color: #60677e !important;
  font-size: 13px !important;
}

.settings_paginationdark__Hz6pf {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.settings_formthemelight__HnEnB {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.settings_formthemedark__ffb0i {
  background-color: #132337;
  color: #60677e !important;
  font-size: 14px;
}
.settings_formthemedark__ffb0i ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.settings_viewformlight__AIIgi {
  background-color: #f3f6f9;
}

.settings_permissionboxlight__UvL2i {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.settings_permissionboxdark__qBhr4 {
  background-color: #0f1824;
  border: solid 1px #242434;
}

.settings_errormsgclr__QmeiF {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.settings_graphclrlight__rlfpD {
  background-color: #fff;
}

.settings_graphclrdark__tho2P {
  background-color: #132337;
}

/* 
Counter theme
*/
#settings_card1bglight__mR3L5 {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#settings_card1bgdark__HX9ph {
  background: #392f28;
}

#settings_card2bglight__\\+y-JH {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#settings_card2bgdark__Kfhe7 {
  background: #1c3238;
}

#settings_card3bglight__XbcQO {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#settings_card3bgdark__ILj6B {
  background: #3a2434;
}

#settings_card4bglight__fGD5L {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#settings_card4bgdark__0tK9O {
  background: #2f264f;
}

#settings_card1bgdark__HX9ph a,
#settings_card1bgdark__HX9ph p,
#settings_card2bgdark__Kfhe7 a,
#settings_card2bgdark__Kfhe7 p,
#settings_card3bgdark__ILj6B a,
#settings_card3bgdark__ILj6B p,
#settings_card4bgdark__0tK9O a,
#settings_card4bgdark__0tK9O p {
  color: #fff;
}

/* 
Action button theme
*/
.settings_actionbtnlight__4Sk0H {
  color: rgba(70, 71, 91, 0.8705882353);
}

.settings_actionbtnlight__4Sk0H:hover {
  cursor: pointer;
}

.settings_actionbtndark__La-Jh {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.settings_profiledropdownlight__NbgyO {
  background-color: #fff;
}

.settings_profiledropdowndark__D0QpQ {
  background-color: #151521;
}

.settings_settingsection__xu5at #settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

#settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_savebtn__yNpbe {
  background-color: #3b82f6;
  color: #fff;
}

.settings_profile_conatiner__rzq8z {
  border-radius: 5px !important;
}

.settings_bodythemedark__CUjRX .settings_ag-theme-alpine__wCbtM .settings_ag-row__xu1As {
  background: #000 !important;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt {
  background-color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_formbtn__mm3Wt:hover {
  background-color: #2563eb;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY {
  color: #fff;
  background-color: transparent;
  border: solid 1px #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_resetbtn__FRARY:hover {
  background-color: #3b82f6;
}

.settings_headingdark__n\\+TEX span {
  background-color: #132337;
}

.settings_resetbtn__FRARY {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #131f43;
  color: #131f43;
  min-width: 113px;
}

.settings_resetbtn__FRARY:hover,
.settings_resetbtn__FRARY:active,
.settings_resetbtn__FRARY:focus {
  background-color: #131f43;
  color: #fff;
}

.settings_addBtn__eaiUM {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38a169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.settings_addbtnlight__gWrRV {
  background-color: #38a169;
}

.settings_addbtndark__NmlKJ {
  background-color: #3b82f6;
}

.settings_addbtndark__NmlKJ:hover {
  background-color: #2563eb;
}

.settings_formthemedark__ffb0i label {
  color: #92afd3;
}

.settings_addBtn__eaiUM svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.settings_addBtn__eaiUM:hover {
  color: #fff;
  background-color: #38a169;
  border: none;
}

.settings_cust_addBtn__OhiGl.settings_addBtn__eaiUM svg {
  top: 2px;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju {
  min-width: 130px;
  height: 50px;
  background-color: #f94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #f94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.settings_deleteBtn__bL4Ju svg {
  margin-right: 10px;
  position: relative;
  top: -2px;
}

.settings_deleteBtn__bL4Ju:hover,
.settings_deleteBtn__bL4Ju:active,
.settings_deleteBtn__bL4Ju:focus {
  background-color: #f94747;
  color: #fff;
  border: none;
}

.settings_confirmBtn__Wnp0z {
  background-color: #131f43;
}

.settings_confirmBtn__Wnp0z:hover,
.settings_confirmBtn__Wnp0z:active,
.settings_confirmBtn__Wnp0z:focus {
  background-color: #131f43;
}

.settings_confirmBtn__Wnp0z svg {
  top: 0;
}

.settings_delPopContainer__FCjdY .settings_modal-body__MJgKL {
  padding: 25px;
  text-align: center;
}

.settings_delPopContainer__FCjdY .settings_delet_icon__uP6T3 {
  margin-bottom: 11px;
}

.settings_delPopContainer__FCjdY p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.settings_arrowback__qnVSX svg {
  fill: #000;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX {
  background-color: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_arrowback__qnVSX svg {
  fill: #3b82f6;
}

.settings_bodythemedark__CUjRX .settings_drpdwn_btn__PsPxB {
  background-color: #132337;
}

.settings_bodythemedark__CUjRX .settings_empname__6QldI {
  color: #92afd3 !important;
}

.settings_bodythemedark__CUjRX .settings_navitemli__4IC51 a {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingsgeneral__0GBoO,
.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z:hover {
  background-color: #3b82f6;
  color: #fff;
}

.settings_bodythemedark__CUjRX .settings_tabnavli__-QWK2 a.settings_settingslinks__vcT1Z {
  background-color: transparent;
  border: solid 1px #3b82f6;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV {
  background-color: #1c2e45;
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd h5 {
  color: #fff;
}

.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV ul li a:hover,
.settings_headerthemedark__VXMQL .settings_dropdown_menu_contain__H2iGV .settings_dropdown_item__Ioitd:hover {
  background-color: #132337;
  color: #fff;
}

.settings_dropdown_item__Ioitd:active {
  background-color: #f5f6fa;
}

.settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #132337;
}

.settings_headerthemedark__VXMQL .settings_profile_arrrow_dwn__\\+vDFh {
  stroke: #fff;
}

.settings_dateinputbox1__enon- input,
.settings_dateinputbox1__enon- span {
  color: #fff !important;
}

/* LOGOUT MODAL */
@media only screen and (max-width: 1200px) {
  .settings_tableheadlight__I2wDM th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .settings_dashboard__FHk5D {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
  .settings_cont2__VlNwH {
    height: calc(100vh - 160px);
    overflow-y: auto;
  }
}
@media only screen and (max-width: 998px) {
  /* #dashboardcont2{
    height: auto !important;
  }*/
}
@media only screen and (min-width: 767px) {
  .settings_messageminwidth__UaZ5Y {
    white-space: normal;
    word-wrap: break-word;
    width: 37%;
  }
}
@media only screen and (max-width: 767px) {
  td {
    max-width: 700px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .settings_messageminwidth__UaZ5Y {
    white-space: nowrap;
    word-wrap: break-word;
  }
  .settings_sectionright__lAAyc {
    float: unset !important;
  }
  .settings_dashboard__FHk5D {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .settings_cont2__VlNwH {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 10px !important;
    overflow-x: inherit !important;
  }
  .settings_bodythemelight__daVLj,
  .settings_bodythemedark__CUjRX {
    padding-top: 83px;
  }
  .settings_top_header__ff-Zj {
    min-height: 69px;
  }
}
@media (min-width: 576px) {
  .settings_exer_modal_contain__Yk2sS .settings_modal-dialog__6cI4N {
    max-width: 1055px;
  }
  .settings_delPopContainer__FCjdY .settings_modal-dialog__6cI4N {
    max-width: 350px;
  }
}
.settings_settingsection__xu5at {
  margin-bottom: 50px;
  padding-bottom: 30px;
}
.settings_settingsection__xu5at #settings_settingsheading__E8AHc {
  font-size: 18px;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO {
  text-decoration: none;
  letter-spacing: 0.15em;
  display: inline-block;
  position: relative;
  color: #fff;
  background-color: #131f43;
}
.settings_settingsection__xu5at .settings_settingslinks__vcT1Z:hover {
  color: #fff;
  background-color: #131f43;
}
.settings_settingsection__xu5at .settings_settingsgeneral__0GBoO:hover {
  color: #fff;
  background-color: #131f43;
}
.settings_settingsection__xu5at #settings_layoutnav__xQYLn {
  border-radius: 5px;
}

#settings_addform__Dk7Mj {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  padding-bottom: 30px;
}
#settings_addform__Dk7Mj #settings_addheading__8sSM1 {
  font-size: 18px;
  margin-left: 10px;
}
#settings_addform__Dk7Mj .settings_profilepicdiv__Ss0Bp {
  border-radius: 5px;
}
#settings_addform__Dk7Mj .settings_profilepic__UGYop {
  width: 100%;
  height: auto;
  border-radius: 5px;
}
#settings_addform__Dk7Mj .settings_penicon__ZuNGm {
  margin-right: 5px;
}
#settings_addform__Dk7Mj .settings_namesection__RALe5 {
  display: inline-block;
  margin-left: 20px;
}
#settings_addform__Dk7Mj .settings_profilename__k9Lxn {
  font-size: 16px;
  margin-top: 30px;
}
#settings_addform__Dk7Mj .settings_profileedit__4Yezz {
  font-size: 14px;
  text-decoration: none;
  color: #fff;
  background-color: #131f43;
  padding: 10px;
  border-radius: 4px;
}
#settings_addform__Dk7Mj .settings_editbtntop__Z0lq1 {
  float: right;
}
#settings_addform__Dk7Mj #settings_empdiv__4VsT3 {
  padding: 0px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#settings_addform__Dk7Mj #settings_empdiv__4VsT3 .settings_title__D0MTR {
  font-size: 13px;
  font-weight: 600;
  color: #727272;
  margin-bottom: 7px;
  display: block;
}
#settings_addform__Dk7Mj #settings_empdiv__4VsT3.settings_viewformlight__AIIgi .settings_empname__6QldI {
  color: #131f43;
}
#settings_addform__Dk7Mj #settings_empdiv__4VsT3 .settings_empname__6QldI {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  padding-bottom: 0px;
  word-break: break-word;
}

.settings_viewformlight__AIIgi {
  background-color: transparent;
}

.settings_bodythemedark__CUjRX #settings_addform__Dk7Mj.settings_formthemedark__ffb0i .settings_profileedit__4Yezz {
  background-color: #3b82f6;
  color: #fff;
}

.settings_bodythemelight__daVLj #settings_addform__Dk7Mj.settings_formthemelight__HnEnB .settings_profileedit__4Yezz {
  background-color: #131f43;
  color: #fff;
}

.settings_formthemedark__ffb0i #settings_empdiv__4VsT3 .settings_title__D0MTR {
  color: #fff !important;
}

@media only screen and (max-width: 992px) {
  .settings_editbtntop__Z0lq1 {
    float: left !important;
  }
}
@media only screen and (max-width: 878px) {
  #settings_layoutnav__xQYLn {
    display: flex !important;
  }
  .settings_settingslinks__vcT1Z {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  .settings_settingsgeneral__0GBoO {
    margin-right: 8px !important;
    font-size: 14px !important;
  }
  #settings_addform__Dk7Mj .settings_profilepic__UGYop {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 510px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
  .settings_settingsgeneral__0GBoO {
    margin-right: 6px !important;
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 495px) {
  .settings_settingslinks__vcT1Z {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
  .settings_settingsgeneral__0GBoO {
    margin-right: 5px !important;
    font-size: 12px !important;
  }
}
@media only screen and (max-width: 331px) {
  .settings_settingsgeneral__0GBoO, .settings_settingslinks__vcT1Z {
    padding: 12px !important;
  }
  .settings_namesection__RALe5 {
    margin-left: 5px !important;
  }
}
@media only screen and (max-width: 600px) {
  #settings_dashboardcont2__qbjfj {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/settings.module.scss"],"names":[],"mappings":"AAEA;EACE,mCAAA;ACAF;;ADGA;;EAAA;AAgDA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AAQA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAhBe;EAiBf,kBAAA;EACA,WAhBc;EAiBd,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAvFO;EAwFP,2BAAA;EACA,gBAAA;ACrEF;;ADuEA;EACE,yBAAA;EACA,yBA7FO;EA8FP,kBAAA;ACpEF;;ADsEA;;;EAGE,yBAjEmB;ACFrB;;ADqEA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;AClEF;;ADqEA;;CAAA;AAIA;EACE,wBAvCU;EAwCV,UAvCS;EAwCT,kBAAA;EACA,aA/CiB;EAgDjB,kBAAA;EACA,mBArHO;EAsHP,2BAAA;EACA,2BAAA;EACA,gBAAA;EACA;;;GAAA;AChEF;;ADsEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACnEF;;ADsEA;EACE,YAAA;ACnEF;;ADsEA;EACE,sBA9FY;AC2Bd;;ADsEA;;CAAA;AAGA;EACE,sBArGY;EAsGZ,iBAAA;ACnEF;;ADqEA;EACE,yBApHe;EAqHf,iBAAA;AClEF;;ADqEA;;CAAA;AAGA;EACE,sBAjHY;AC+Cd;;ADqEA;EACE,yBAhIe;AC8DjB;;ADoEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;ACjEF;;ADoEA;;CAAA;AAGA;EACE,sBArIY;ACoEd;;ADmEA;EACE,yBAnJe;ACmFjB;;ADmEA;;CAAA;AAGA;EACE,yBAAA;AChEF;;ADmEA;EACE,yBAAA;AChEF;;ADmEA;;EAEE,sBAAA;AChEF;;ADmEA;EACE,yBArKqB;EAsKrB,cA9KiB;AC8GnB;;ADkEA;EACE,sCAAA;EACA,sBAAA;EACA,yBAAA;AC/DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,yBAAA;AC9DF;;ADiEA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,0BAAA;AC9DF;;ADiEA;EACE,uBAAA;AC9DF;;ADiEA;EACE,yBAnNqB;EAoNrB,WA3MY;AC6Id;;ADiEA;;CAAA;AAGA;EACE,cA/Me;ACiJjB;;ADiEA;EACE,cAnNe;ACqJjB;;ADiEA;;CAAA;AAGA;EACE,sBA7NY;EA8NZ,YAAA;AC9DF;;ADiEA;EACE,yBA7Oe;EA8Of,WAnOY;EAoOZ,YAAA;AC9DF;;ADgEA;EACE,cApOe;ACuKjB;;ADgEA;;CAAA;AAGA;EACE,yBAzRc;EA0Rd,8BAAA;AC7DF;;AD+DA;EACE,WAlPY;EAmPZ,yBAAA;AC5DF;;AD8DA;;EAEE,0BAAA;AC3DF;;AD6DA;;EAEE,0BAAA;AC1DF;;AD4DA;EACE,kBAAA;ACzDF;;AD2DA;EACE,kBAAA;ACxDF;;AD0DA;EACE,oCAAA;EACA,gCAAA;ACvDF;;AD0DA;EACE,yBAjQkB;EAkQlB,WA1QY;ACmNd;;ADyDA;EACE,yBAAA;ACtDF;;ADwDA;EACE,iBAAA;ACrDF;;ADuDA;;EAEE,+BAAA;EACA,iBAAA;ACpDF;;ADsDA;EACE,sBAxRY;ACqOd;ADqDE;EACE,yBAAA;EACA,YAAA;ACnDJ;;ADsDA;EACE,0CAAA;EACA,cA9Re;AC2OjB;ADqDE;EACE,yCAAA;EACA,YAAA;ACnDJ;;ADuDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;ACpDF;;ADsDA;EACE,yBAAA;EACA,0BAAA;ACnDF;;ADsDA;;CAAA;AAGA;EACE,sBAzTY;EA0TZ,yBAAA;EACA,qDAAA;ACnDF;;ADqDA;EACE,yBAtTkB;EAuTlB,yBAAA;EACA,eAAA;AClDF;ADoDE;EACE,cAhUa;AC8QjB;;ADsDA;;CAAA;AAGA;EACE,yBA9UgB;AC2RlB;;ADsDA;EACE,yBAAA;EACA,yBAAA;ACnDF;;ADqDA;EACE,yBA7VmB;EA8VnB,yBAAA;AClDF;;ADqDA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AClDF;;ADqDA;;CAAA;AAGA;EACE,sBAjWY;AC+Sd;;ADqDA;EACE,yBA7VkB;AC2SpB;;ADqDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA7WY;AC2Td;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAtXY;ACoUd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBA/XY;AC6Ud;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;EACE,gGAAA;EACA,sBAxYY;ACsVd;;ADqDA;EACE,mBAAA;AClDF;;ADqDA;;;;;;;;EAQE,WAvZY;ACqWd;;ADqDA;;CAAA;AAGA;EACE,qCAAA;AClDF;;ADoDA;EACE,eAAA;ACjDF;;ADmDA;EACE,cAjae;ACiXjB;;ADmDA;;CAAA;AAGA;EACE,sBAAA;AChDF;;ADmDA;EACE,yBAAA;AChDF;;ADmDA;EACE,yBAlciB;EAmcjB,WApbY;ACoYd;;ADkDA;EACE,yBAtciB;EAucjB,WAxbY;ACyYd;;ADkDA;EACE,6BAAA;AC/CF;;ADkDA;EACE,2BAAA;AC/CF;;ADkDA;EACE,yBAndiB;ACoanB;;ADkDA;EACE,yBAtduB;ACuazB;;ADkDA;EACE,WA5cY;EA6cZ,6BAAA;EACA,yBAAA;AC/CF;;ADkDA;EACE,yBAjeiB;ACkbnB;;ADkDA;EACE,yBAjee;ACkbjB;;ADkDA;EACE,eAAA;EACA,gBA5gBc;EA6gBd,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cA1gBc;EA2gBd,gBAAA;AC/CF;;ADiDA;;;EAGE,yBAhhBc;EAihBd,WAteY;ACwbd;;ADiDA;EACE,gBAAA;EACA,YAAA;EACA,WA5eY;EA6eZ,yBAtgBY;EAugBZ,YAAA;EACA,eAAA;EACA,gBAjiBc;ACmfhB;;ADiDA;EACE,yBA7gBY;AC+dd;;ADgDA;EACE,yBAtgBiB;ACydnB;;AD+CA;EACE,yBAxgBuB;AC4dzB;;AD+CA;EACE,cA9gBgB;ACkelB;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;AC5CF;;AD+CA;EACE,WAxgBY;EAygBZ,yBAliBY;EAmiBZ,YAAA;AC5CF;;AD+CA;EACE,QAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAtiBU;EAuiBV,WArhBY;EAshBZ,eAAA;EACA,gBAxkBc;EAykBd,YAAA;AC5CF;;AD+CA;EACE,gBAAA;EACA,YAAA;EACA,yBAhjBU;EAijBV,WA/hBY;EAgiBZ,eAAA;EACA,gBAllBc;EAmlBd,YAAA;AC5CF;;AD+CA;;EAEE,oCAAA;EACA,sBAAA;EACA,2BAAA;AC5CF;;AD+CA;EACE,kBAAA;EACA,kBAAA;EACA,SAAA;AC5CF;;AD+CA;;;EAGE,yBAvkBU;EAwkBV,WAtjBY;EAujBZ,YAAA;AC5CF;;AD+CA;EACE,yBAtmBc;AC0jBhB;;AD+CA;;;EAGE,yBA5mBc;ACgkBhB;;AD+CA;EACE,MAAA;AC5CF;;AD+CA;EACE,aAAA;EACA,kBAAA;AC5CF;;AD+CA;EACE,mBAAA;AC5CF;;AD+CA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AC5CF;;AD+CA;EACE,UAAA;AC5CF;;AD+CA;EACE,yCAzmBa;EA0mBb,cA9mBiB;ACkkBnB;;AD+CA;EACE,aAlnBiB;ACskBnB;;AD+CA;EACE,yBAhnBe;ACokBjB;;AD+CA;EACE,yBAAA;AC5CF;;AD+CA;EACE,6BAAA;EACA,yBAAA;EACA,WA/mBY;ACmkBd;;AD+CA;;EAEE,yBAnoBiB;EAooBjB,WArnBY;ACykBd;;AD8CA;EACE,6BAAA;EACA,yBAAA;EACA,WA1nBY;AC+kBd;;AD8CA;EACE,yBAvoBqB;EAwoBrB,WA/nBY;AColBd;;AD8CA;;;EAGE,WAroBY;AC0lBd;;AD8CA;;EAEE,yBArpBe;EAspBf,WA3oBY;ACgmBd;;AD8CA;EACE,yBA3rBO;ACgpBT;;AD8CA;EACE,eA9pBe;ACmnBjB;;AD8CA;EACE,YAvpBY;AC4mBd;;AD8CA;;EAEE,sBAAA;AC3CF;;AD8CA,iBAAA;AAOA;EACE;IACE,gBAAA;ECjDF;AACF;ADmDA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECjDF;EDmDA;IACE,2BAAA;IACA,gBAAA;ECjDF;AACF;ADmDA;EACE;;IAAA;AC/CF;ADmDA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;ECjDF;AACF;ADoDA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EClDF;EDoDA;IACE,mBAAA;IACA,qBAAA;EClDF;EDoDA;IACE,uBAAA;EClDF;EDoDA;IACE,6BAAA;EClDF;AACF;ADoDA;EAEE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,wBAAA;IACA,8BAAA;ECnDF;EDqDA;;IAEE,iBAAA;ECnDF;EDqDA;IACE,gBAAA;ECnDF;AACF;ADsDA;EACE;IACE,iBAAA;ECpDF;EDsDA;IACE,gBAAA;ECpDF;AACF;AApvBA;EACI,mBAAA;EACA,oBAAA;AAsvBJ;AApvBI;EACI,eAAA;AAsvBR;AApvBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAsvBR;AAnvBI;EACI,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WDwCM;ECvCN,yBDoDW;ACisBnB;AAjvBI;EACI,WDkCM;ECjCN,yBD8CW;ACqsBnB;AAhvBI;EACI,WD6BM;EC5BN,yBDyCW;ACysBnB;AA/uBM;EACE,kBAAA;AAivBR;;AA5uBY;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AA+uBhB;AA9uBgB;EACI,eAAA;EACA,iBAAA;AAgvBpB;AA9uBgB;EACI,kBAAA;AAgvBpB;AA9uBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAgvBpB;AA9uBgB;EACI,iBAAA;AAgvBpB;AA7uBgB;EACI,qBAAA;EACA,iBAAA;AA+uBpB;AA5uBgB;EACI,eAAA;EACA,gBAAA;AA8uBpB;AA5uBgB;EACI,eAAA;EAEA,qBAAA;EACA,WDfN;ECgBM,yBDHD;ECIC,aAAA;EACA,kBAAA;AA6uBpB;AA1uBgB;EACI,YAAA;AA4uBpB;AAxuBoB;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AA0uBxB;AAxuBwB;EACI,eAAA;EACA,gBDlFZ;ECmFY,cD3EX;EC4EW,kBAAA;EACA,cAAA;AA0uB5B;AAvuB4B;EACI,cDnFhB;AC4zBhB;AAtuBwB;EACI,eAAA;EACA,gBD9FZ;EC+FY,WD9Cd;EC+Cc,mBAAA;EACA,sBAAA;AAwuB5B;;AAnuBA;EACI,6BAAA;AAsuBJ;;AAnuBA;EACI,yBDzEe;EC0Ef,WD3DU;ACiyBd;;AAnuBA;EACI,yBD1GY;EC2GZ,WDhEU;ACsyBd;;AAnuBA;EACI,sBAAA;AAsuBJ;;AAhtBC;EACG;IACG,sBAAA;EAmtBL;AACF;AAhtBA;EACI;IACI,wBAAA;EAktBN;EAhtBI;IACE,4BAAA;IACA,0BAAA;EAktBN;EAhtBE;IACI,4BAAA;IACA,0BAAA;EAktBN;EAhtBE;IACI,mBAAA;EAktBN;AACF;AA/sBA;EACM;IACE,4BAAA;IACA,0BAAA;EAitBN;EA/sBE;IACI,4BAAA;IACA,0BAAA;EAitBN;AACF;AA9sBA;EACI;IACE,4BAAA;IACA,0BAAA;EAgtBJ;EA9sBA;IACI,4BAAA;IACA,0BAAA;EAgtBJ;AACF;AA5sBA;EACE;IACE,wBAAA;EA8sBF;EA5sBA;IACE,2BAAA;EA8sBF;AACF;AAvsBA;EACI;IACI,wBD1HI;IC2HJ,UD1HG;IC2HH,kBAAA;IACA,aDlIW;EC20BjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: 'Urbanist', sans-serif;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #f5f6fa;\n$primary-color: #131f43;\n$icon-bgcolor: #f6f6f6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #f3f4f8;\n$cardIcon1-darkbg: #30231a;\n$cardIcon1-darkbg-icon: #9d785f;\n$cardIcon2-bg: #faf4fb;\n$cardIcon2-darkbg: #13252a;\n$cardIcon2-darkbg-icon: #3b606a;\n$cardIcon3-bg: #faf7f3;\n$cardIcon3-darkbg: #2c1a27;\n$cardIcon3-darkbg-icon: #6c4863;\n$cardIcon4-bg: #f5f9fc;\n$cardIcon4-darkbg: #241d3e;\n$cardIcon4-darkbg-icon: #5f538b;\n$cardIcon2-color: #ac44bb;\n$cardIcon3-color: #d69a5f;\n$cardIcon4-color: #176ca5;\n$green-color: #38a169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading: #0b0d0f;\n$light-gray: #999999;\n$menu_icon: #cbcbcb;\n$red-color: #f94747;\n$dark-active-blue: #3b82f6;\n$dark-light-blue: #92afd3;\n$addBtn-dark-blue: #3b82f6;\n$addBtn-dark-blue-hover: #2563eb;\n$backBtn-dark: #3b82f633;\n\n$darkTheme_blue: #132337;\n$darkTheme_darkBlue: #0f1824;\n$darkTheme_selectBlue: #1c2e45;\n$darkTheme_updateBtn: #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #132337;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #131f43;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: $dashboardwidth;\n  position: relative;\n  left: $dashboardleft;\n  padding: 35px 35px;\n  border-radius: 0px;\n  min-height: auto !important;\n  background-color: $mainBg;\n  height: calc(100vh - 160px);\n  overflow-y: auto;\n}\n.dashboardContain {\n  width: calc(100% - 320px);\n  background-color: $mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard,\n.bodythemedark .cont2 {\n  background-color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  height: calc(100vh - 160px);\n  min-height: auto !important;\n  overflow-y: auto;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1;\n  top: 0;\n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span,\n.menulinklight:hover a {\n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $dark-active-blue;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n.menuthemelight .menulinklightSelected svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinkdark {\n  color: $dark-light-blue !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: #0f4d0f;\n}\n\n.menulinklight:hover svg path {\n  color: $white-color !important;\n  fill: #fff;\n  stroke: #fff;\n}\n\n.menulinklight .sub_arrow svg path {\n  stroke: $menu_icon !important;\n}\n\n.menulinklight:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark .sub_arrow svg path {\n  stroke: $dark-light-blue !important;\n}\n\n.menulinkdark:hover .sub_arrow svg path {\n  stroke: $white-color !important;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n  background-color: #0f4d0f;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n}\nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n}\ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless {\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #f9fafb;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td,\n.tablebodydark td {\n  padding: 0.5rem 1rem !important;\n  line-height: 30px;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: auto;\n  }\n}\n.tablebodydark {\n  /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: auto;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: $darkTheme_darkBlue;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card1bgdark {\n  background: #392f28;\n}\n\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a,\n#card1bgdark p,\n#card2bgdark a,\n#card2bgdark p,\n#card3bgdark a,\n#card3bgdark p,\n#card4bgdark a,\n#card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n.actionbtnlight:hover {\n  cursor: pointer;\n}\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important;\n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $addBtn-dark-blue;\n}\n\n.bodythemedark .formbtn:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $addBtn-dark-blue;\n}\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color: $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover,\n.resetbtn:active,\n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addbtnlight {\n  background-color: $green-color;\n}\n.addbtndark {\n  background-color: $addBtn-dark-blue;\n}\n.addbtndark:hover {\n  background-color: $addBtn-dark-blue-hover;\n}\n\n.formthemedark label {\n  color: $dark-light-blue;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: 130px;\n  height: 50px;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important;\n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover,\n.deleteBtn:active,\n.deleteBtn:focus {\n  background-color: $red-color;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover,\n.confirmBtn:active,\n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg {\n  fill: #000;\n}\n\n.bodythemedark .arrowback {\n  background-color: $backBtn-dark;\n  color: $dark-active-blue;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $dark-active-blue;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $dark-light-blue !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral,\n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $addBtn-dark-blue;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $addBtn-dark-blue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a,\n.headerthemedark .dropdown_menu_contain .dropdown_item,\n.headerthemedark .dropdown_menu_contain .dropdown_item h5 {\n  color: $white-color;\n}\n\n.headerthemedark .dropdown_menu_contain ul li a:hover,\n.headerthemedark .dropdown_menu_contain .dropdown_item:hover {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n}\n\n.dropdown_item:active {\n  background-color: $mainBg;\n}\n\n.profile_arrrow_dwn {\n  stroke: $darkTheme_blue;\n}\n\n.headerthemedark .profile_arrrow_dwn {\n  stroke: $white-color;\n}\n\n.dateinputbox1 input,\n.dateinputbox1 span {\n  color: $white-color !important;\n}\n\n/* LOGOUT MODAL */\n.modalStyleLight {\n}\n\n.modalStyleDark {\n}\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) {\n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n  .cont2 {\n    height: calc(100vh - 160px);\n    overflow-y: auto;\n  }\n}\n@media only screen and (max-width: 998px) {\n  /* #dashboardcont2{\n    height: auto !important;\n  }*/\n}\n@media only screen and (min-width: 767px) {\n  .messageminwidth {\n    white-space: normal;\n    word-wrap: break-word;\n    width: 37%;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  td {\n    max-width: 700px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  .messageminwidth {\n    white-space: nowrap;\n    word-wrap: break-word;\n  }\n  .sectionright {\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n \n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 10px !important;\n    overflow-x: inherit !important;\n  }\n  .bodythemelight,\n  .bodythemedark {\n    padding-top: 83px;\n  }\n  .top_header {\n    min-height: 69px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n    max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n    max-width: 350px;\n  }\n}\n","@import \"../../styles/Variables/Variables.scss\";\n.settingsection{\n    margin-bottom: 50px;\n    padding-bottom:30px;\n\n    #settingsheading{\n        font-size: 18px;\n    }\n    .settingslinks{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n    }\n\n    .settingsgeneral{\n        text-decoration: none;\n        letter-spacing: 0.15em;\n        display: inline-block;\n        position: relative; \n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n\n    \n    .settingslinks:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n    }\n    \n    .settingsgeneral:hover{\n        color: $white-color;\n        background-color: $primary-btncolor;\n      }\n\n      #layoutnav{\n        border-radius: 5px;\n      }\n\n}\n                \n            #addform{\n                width: 100%;\n                border-radius: 5px;\n                margin-top: 30px;\n                padding-bottom:30px;\n                #addheading{\n                    font-size: 18px;\n                    margin-left: 10px;\n                }\n                .profilepicdiv{\n                    border-radius: 5px;\n                }\n                .profilepic{\n                    width: 100%;\n                    height: auto;\n                    border-radius: 5px;\n                }\n                .penicon{\n                    margin-right: 5px;\n                }\n\n                .namesection{\n                    display: inline-block;\n                    margin-left: 20px;\n                }\n\n                .profilename{\n                    font-size: 16px;\n                    margin-top: 30px;\n                }\n                .profileedit{\n                    font-size: 14px;\n                     \n                    text-decoration: none;\n                    color: $white-color;\n                    background-color: $primary-btncolor;\n                    padding: 10px;\n                    border-radius: 4px;\n                }\n            \n                .editbtntop{\n                    float: right;\n                }\n\n\n                    #empdiv{\n                        padding:0px 0px 0px 15px;\n                        margin-bottom: 10px;\n                        border-radius: 5px;\n\n                        .title{\n                            font-size: 13px;\n                            font-weight: $font-semiBold;\n                            color: $text-graycolor;\n                            margin-bottom: 7px;\n                            display: block;\n                        }\n                        &.viewformlight {\n                            .empname{\n                                color: $primary-color;\n                            }\n                        }\n                        .empname{\n                            font-size: 16px;\n                            font-weight: $font-semiBold;\n                            color: $white-color;\n                            padding-bottom:0px;\n                            word-break: break-word;\n                        }\n                    }\n            }\n\n.viewformlight {\n    background-color: transparent;\n}\n\n.bodythemedark #addform.formthemedark .profileedit {\n    background-color: $addBtn-dark-blue;\n    color: $white-color;\n}\n\n.bodythemelight #addform.formthemelight .profileedit {\n    background-color: $primary-color;\n    color: $white-color;\n}\n\n.formthemedark #empdiv .title {\n    color: $white-color !important;\n}\n  \n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 40px !important;\n//     }\n//     }\n\n// @media only screen and (max-width: 1324px) {\n//     .editbtntop{\n//         margin-left: 20px !important;\n//     }\n// }\n\n// @media only screen and (max-width: 1200px) {\n//     .editbtntop{\n//         margin-left: 50px !important;\n//     }\n// }\n\n @media only screen and (max-width: 992px) {\n    .editbtntop{\n       float: left !important;\n    }\n}\n\n@media only screen and (max-width: 878px) {\n    #layoutnav{\n        display: flex !important;\n      }\n      .settingslinks{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    .settingsgeneral{\n        margin-right: 8px !important;\n        font-size: 14px !important;\n    }\n    #addform .profilepic{ \n        margin-bottom: 30px;\n    }\n}\n\n@media only screen and (max-width: 510px) {\n      .settingslinks{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n    .settingsgeneral{\n        margin-right: 6px !important;\n        font-size: 13px !important;\n    }\n}\n\n@media only screen and (max-width: 495px) {\n    .settingslinks{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n  .settingsgeneral{\n      margin-right: 5px !important;\n      font-size: 12px !important;\n  }\n}\n\n\n@media only screen and (max-width: 331px) {\n  .settingsgeneral,  .settingslinks{\n    padding: 12px !important;\n  }\n  .namesection{\n    margin-left: 5px !important;\n\n}\n}\n\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `settings_dashboard__FHk5D`,
	"dashboardContain": `settings_dashboardContain__U2OSm`,
	"bodythemedark": `settings_bodythemedark__CUjRX`,
	"cont2": `settings_cont2__VlNwH`,
	"top_header": `settings_top_header__ff-Zj`,
	"top_header_inner": `settings_top_header_inner__CdYKG`,
	"subLink": `settings_subLink__DFs3N`,
	"footer": `settings_footer__P4xQU`,
	"bodythemelight": `settings_bodythemelight__daVLj`,
	"headerthemelight": `settings_headerthemelight__-DecU`,
	"headerthemedark": `settings_headerthemedark__VXMQL`,
	"menuthemelight": `settings_menuthemelight__xa936`,
	"menuthemedark": `settings_menuthemedark__0RlW9`,
	"menulinklight": `settings_menulinklight__2ukHf`,
	"menulinkdarkSelected": `settings_menulinkdarkSelected__qg5eL`,
	"menulinklightSelected": `settings_menulinklightSelected__-Sh8x`,
	"menulinkdark": `settings_menulinkdark__ZEp0Q`,
	"sub_arrow": `settings_sub_arrow__fGoo-`,
	"headinglight": `settings_headinglight__doSQ0`,
	"headingdark": `settings_headingdark__n+TEX`,
	"searchboxlight": `settings_searchboxlight__Exe8H`,
	"searchboxdark": `settings_searchboxdark__0LYGy`,
	"tableheadlight": `settings_tableheadlight__I2wDM`,
	"tableheaddark": `settings_tableheaddark__BAzcZ`,
	"table": `settings_table__wcs2I`,
	"table-borderless": `settings_table-borderless__XlVcO`,
	"left-section": `settings_left-section__Mo-jA`,
	"tablebodylight": `settings_tablebodylight__F8haX`,
	"tablebodydark": `settings_tablebodydark__qeszF`,
	"paginationlight": `settings_paginationlight__BGULt`,
	"paginationdark": `settings_paginationdark__Hz6pf`,
	"formthemelight": `settings_formthemelight__HnEnB`,
	"formthemedark": `settings_formthemedark__ffb0i`,
	"viewformlight": `settings_viewformlight__AIIgi`,
	"permissionboxlight": `settings_permissionboxlight__UvL2i`,
	"permissionboxdark": `settings_permissionboxdark__qBhr4`,
	"errormsgclr": `settings_errormsgclr__QmeiF`,
	"graphclrlight": `settings_graphclrlight__rlfpD`,
	"graphclrdark": `settings_graphclrdark__tho2P`,
	"card1bglight": `settings_card1bglight__mR3L5`,
	"card1bgdark": `settings_card1bgdark__HX9ph`,
	"card2bglight": `settings_card2bglight__+y-JH`,
	"card2bgdark": `settings_card2bgdark__Kfhe7`,
	"card3bglight": `settings_card3bglight__XbcQO`,
	"card3bgdark": `settings_card3bgdark__ILj6B`,
	"card4bglight": `settings_card4bglight__fGD5L`,
	"card4bgdark": `settings_card4bgdark__0tK9O`,
	"actionbtnlight": `settings_actionbtnlight__4Sk0H`,
	"actionbtndark": `settings_actionbtndark__La-Jh`,
	"profiledropdownlight": `settings_profiledropdownlight__NbgyO`,
	"profiledropdowndark": `settings_profiledropdowndark__D0QpQ`,
	"settingsection": `settings_settingsection__xu5at`,
	"addform": `settings_addform__Dk7Mj`,
	"savebtn": `settings_savebtn__yNpbe`,
	"profile_conatiner": `settings_profile_conatiner__rzq8z`,
	"ag-theme-alpine": `settings_ag-theme-alpine__wCbtM`,
	"ag-row": `settings_ag-row__xu1As`,
	"formbtn": `settings_formbtn__mm3Wt`,
	"resetbtn": `settings_resetbtn__FRARY`,
	"addBtn": `settings_addBtn__eaiUM`,
	"addbtnlight": `settings_addbtnlight__gWrRV`,
	"addbtndark": `settings_addbtndark__NmlKJ`,
	"cust_addBtn": `settings_cust_addBtn__OhiGl`,
	"deleteBtn": `settings_deleteBtn__bL4Ju`,
	"confirmBtn": `settings_confirmBtn__Wnp0z`,
	"delPopContainer": `settings_delPopContainer__FCjdY`,
	"modal-body": `settings_modal-body__MJgKL`,
	"delet_icon": `settings_delet_icon__uP6T3`,
	"arrowback": `settings_arrowback__qnVSX`,
	"drpdwn_btn": `settings_drpdwn_btn__PsPxB`,
	"empname": `settings_empname__6QldI`,
	"navitemli": `settings_navitemli__4IC51`,
	"tabnavli": `settings_tabnavli__-QWK2`,
	"settingsgeneral": `settings_settingsgeneral__0GBoO`,
	"settingslinks": `settings_settingslinks__vcT1Z`,
	"dropdown_menu_contain": `settings_dropdown_menu_contain__H2iGV`,
	"dropdown_item": `settings_dropdown_item__Ioitd`,
	"profile_arrrow_dwn": `settings_profile_arrrow_dwn__+vDFh`,
	"dateinputbox1": `settings_dateinputbox1__enon-`,
	"messageminwidth": `settings_messageminwidth__UaZ5Y`,
	"sectionright": `settings_sectionright__lAAyc`,
	"exer_modal_contain": `settings_exer_modal_contain__Yk2sS`,
	"modal-dialog": `settings_modal-dialog__6cI4N`,
	"settingsheading": `settings_settingsheading__E8AHc`,
	"layoutnav": `settings_layoutnav__xQYLn`,
	"addheading": `settings_addheading__8sSM1`,
	"profilepicdiv": `settings_profilepicdiv__Ss0Bp`,
	"profilepic": `settings_profilepic__UGYop`,
	"penicon": `settings_penicon__ZuNGm`,
	"namesection": `settings_namesection__RALe5`,
	"profilename": `settings_profilename__k9Lxn`,
	"profileedit": `settings_profileedit__4Yezz`,
	"editbtntop": `settings_editbtntop__Z0lq1`,
	"empdiv": `settings_empdiv__4VsT3`,
	"title": `settings_title__D0MTR`,
	"dashboardcont2": `settings_dashboardcont2__qbjfj`
};
export default ___CSS_LOADER_EXPORT___;
